import {
  ref,
  reactive,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from '@vue/composition-api';
import { dynamicTableModel } from '@/models/data-management/dynamic-table';
import usePagination from '@/views/components/pagination/usePagination';
import useFilterHeaderTable from '@/views/components/filter-header-table/useFilterHeaderTable';
import store from '@/store/index';

export default function useMappingBannerModal(props) {
  const vm = getCurrentInstance().proxy;
  const { fetchQueryDataModel } = dynamicTableModel();
  const { pagination } = usePagination();

  const {
    entities,
    filters,
    ordering,
    searchValue,
    onSearch,
  } = useFilterHeaderTable();

  const loading = reactive({
    tableData: false,
  });

  const fields = [
    { key: 'bannerid', label: 'No.' },
    { key: 'banner_image_image_url', label: 'Image' },
    { key: 'name', label: 'Banner Name', sortable: true },
    { key: 'call_to_action', label: 'Call to Action' },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'actions', label: '' },
  ];

  const setMappingBannerTable = reactive({
    column: [],
    payload: [],
    filterColumn: [],
    filter: [],
    isCreate: false,
  });

  const addedMappingBannerList = ref([]);

  const fetchSetBannerMappingList = () => {
    loading.tableData = true;

    fetchQueryDataModel.payload.Page = pagination.currentPage;
    fetchQueryDataModel.payload.Limit = entities.value || pagination.perPage;
    fetchQueryDataModel.payload.Ordering = ordering.value;
    fetchQueryDataModel.payload.Filters = filters.value;
    fetchQueryDataModel.payload.DisplayId = props.queryId;
    fetchQueryDataModel.payload.Display_Key = props.displayKey;
    fetchQueryDataModel.payload.QueryDataId = props.queryId;
    fetchQueryDataModel.payload.QueryData_Key = props.queryDataKey;
    fetchQueryDataModel.payload.IsVerified = true;

    store
      .dispatch('api/apiRequest', fetchQueryDataModel)
      .then((response) => {
        filterMappingBannerList(response.data.payload);
        pagination.rows = response.data.payload.length;
        pagination.totalRows = response.data.filtered_record;
      })
      .catch((error) => {
        //handle error
      })
      .finally(() => {
        loading.tableData = false;
      });
  };

  const addMappingBanner = (banner) => {
    const addBanner = {
      banner_id: banner.bannerid,
      seq: null,
      banner_bci_ref: banner.banner_image_bci_ref,
      banner_image_url: banner.banner_image_image_url,
      banner_name: banner.name,
      call_to_action: banner.call_to_action,
      banner_status: banner.status ? 'Active' : 'Inactive',
      valid_from: banner.valid_from,
      valid_through: banner.valid_through,
      updatedtime: banner.updatedtime,
    };

    addedMappingBannerList.value.push(addBanner);

    filterMappingBannerList(setMappingBannerTable.payload);
    vm.$emit('mapping', addedMappingBannerList.value);
  };

  const resolveCallToAction = (status) => {
    switch (status) {
      case 1:
        return 'None';
      case 2:
        return 'Full Image';
      case 3:
        return 'Landing Page';
      case 4:
        return 'Content Detail';
      case 5:
        return 'Site URL';
      default:
        return 'None';
    }
  };

  const resolveBannerStatusLabel = (status) => {
    switch (status) {
      case true:
        return 'Active';
      case false:
        return 'Inactive';

      default:
        return 'Unknown';
    }
  };

  const initAdddedMappingBannerList = () => {
    addedMappingBannerList.value = [...props.mappingList.payload];
  };

  const filterMappingBannerList = (bannerList) => {
    const filteredBannerList = [...bannerList];

    filteredBannerList.map((banner) => {
      const mappedBanner = addedMappingBannerList.value.find(
        (mappingBanner) => mappingBanner.banner_id == banner.bannerid
      );

      if (mappedBanner) {
        return (banner.mapping = true);
      }

      banner.mapping = false;
    });

    setMappingBannerTable.payload = filteredBannerList;
  };

  const onPageChange = (page) => {
    pagination.currentPage = page;
  };

  const onSearchBanner = (searchInput) => {
    searchValue.query = searchInput;
    onSearch();
  };

  const onModalOpen = () => {
    initAdddedMappingBannerList();
    fetchSetBannerMappingList();
  };

  onBeforeMount(() => {
    initAdddedMappingBannerList();
  });

  watch(
    [entities, filters, ordering],
    () => {
      fetchSetBannerMappingList();
    },
    { deep: true }
  );

  watch(
    pagination,
    () => {
      if (!loading.tableData) {
        fetchSetBannerMappingList();
      }
    },
    { deep: true }
  );

  return {
    fields,
    setMappingBannerTable,
    pagination,
    loading,
    addedMappingBannerList,
    resolveBannerStatusLabel,
    resolveCallToAction,
    addMappingBanner,
    onPageChange,
    onSearchBanner,
    onModalOpen,
  };
}
